import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { AddressModel } from 'Pages/advertisement/models'

export type AddressState = {
	address: ResponseCatalog<AddressModel>
	addressParams: RequestParams
}

export const addressInitialState: AddressState = {
	address: new ResponseCatalog<AddressModel>(),
	addressParams: new RequestParams(),
}

export namespace addressNS {
	export type getAddress = PayloadAction<RequestParams>
	export type setAddress = PayloadAction<ResponseCatalog<AddressModel>>
	export type setAddressParams = PayloadAction<RequestParams>
	export type setPushAddress = PayloadAction<ResponseCatalog<AddressModel>>
}

export const addressSlice = createSlice({
	name: 'address',
	initialState: addressInitialState,
	reducers: {
		getAddress: (state, action: addressNS.getAddress) => {},
		setAddress: (state, action: addressNS.setAddress) => {
			state.address.entries = action.payload.entries.map((item) => {
				const add = { ...item, fias_id: `${item.fias_id};${item.value}`, value: item.value }
				return add
			})
		},
		setAddressParams: (state, action: addressNS.setAddressParams) => {
			state.addressParams = action.payload
		},
		clearAllAddresses: (state) => {
			state.address = new ResponseCatalog<AddressModel>()
			state.addressParams = new RequestParams()
		},
		setPushAddress: (state, action: addressNS.setPushAddress) => {
			state.address.entries = [
				...action.payload.entries.map((item) => {
					const add = { ...item, fias_id: `${item.fias_id};${item.value}`, value: item.value }
					return add
				}),
			]
		},
	},
})
